import BaseAction from "./BaseAction";
import LoadingReducer from "../reducers/LoadingReducer";

class LoadingAction extends BaseAction {
  set = async (loading) => this.dispatch({ loading });
}

const action = new LoadingAction(LoadingReducer);

export default action;
